<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="configs"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <!--      <div slot="toolbar">-->
      <!--        <el-button type="danger" @click="deleteIds">批量删除</el-button>-->
      <!--      </div>-->
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="关键字">
              <el-input v-model.trim="filter.filter" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <w-f-config-edit ref="editWFConfig" @save-success="loadData"/>
  </div>
</template>

<script>
  import WFConfigEdit from "@/views/SystemInfo/WfConfig/WFConfigEdit";
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "WfConfigList",
    components: {WFConfigEdit, ViewTable},
    data() {
      return {
        idList: "",
        limits: {
          addAuth: this.$auth(478),
          editAuth: this.$auth(479),
          delAuth: this.$auth(480),
        },
        filter: {
          filter: "",
        },
        columnsProperty: [
          {
            key: "action",
            align: "center",
            width: 160,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        if(row){
          this.$refs.editWFConfig.open(row.wfconfigID);
        }else{
          this.$refs.editWFConfig.open();
        }
      },
      deleteHandle(row) {

        this.$http.delete("basic", "configs", row.wfconfigID).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });
      },

      onNodeClick(data) {
        this.filter.wfconfigID = data.wfconfigID;
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if (this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.wfconfigID);
          }
          this.$http
              .delete("basic", "configs/deleteByIds", ids).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
            this.idList = "";
          });
        } else {
          this.$message.error("请选择要删除的内容");
        }

      },
    },
  };
</script>

<style scoped>

</style>
